import React from 'react';
import { NextPage } from 'next';
// Hocks
import withApollo from 'hocs/withApollo';
// Layouts
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
import Footer from 'layouts/Footer/Footer';
// Components
import PrivacyPolicyContent from 'components/PrivacyPolicy/PrivacyPolicyContent/PrivacyPolicyContent';

const PrivacyPolicy: NextPage = () => {
  return (
    <>
      <Head
        title="Privacy Policy"
        description="Make money and connect with MILLIONS of fans"
      />
      <Header />
      <PrivacyPolicyContent />
      <Footer />
    </>
  );
};

export default withApollo(PrivacyPolicy);
